import { contextProviderKey, type ContextProvider } from '@logistiek-zonder-papier/lzp-library'
import { defineStore } from 'pinia'
import { inject, ref } from 'vue'

// data-bearing getters only; flowData excluded (circular), genUuid/i18n excluded (behavior, not state)
const SEED_KEYS = [
  'deviceId',
  'subAppId',
  'userId',
  'licensePlate',
  'licensePlateBgb',
  'geoLocation',
] as const

export const useFlowStore = defineStore('flowStore', () => {
  const flowData = ref<Record<string, unknown>>({})
  const globalData = ref<Record<string, unknown>>({})
  const currentPageIndex = ref(0)

  const context = inject<ContextProvider>(contextProviderKey)

  function seedFromContext() {
    if (!context) return

    for (const key of SEED_KEYS) {
      flowData.value[key] = context[key]()
    }
  }

  seedFromContext()

  function setValue(path: string, value: unknown) {
    flowData.value[path] = value
  }

  return { flowData, globalData, currentPageIndex, context, setValue }
})
